"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SecuritySettings = void 0;
var react_1 = __importStar(require("react"));
var mobx_react_1 = require("mobx-react");
var PasswordProtect_1 = require("./PasswordProtect");
var IdentityMapping_1 = require("./IdentityMapping");
var Telemetry_1 = require("Telemetry");
var TelemetryParameterKey_1 = require("Telemetry/TelemetryParameterKey");
var Types_1 = require("@CommonFrontendBackend/Projects/Types");
var SecuritySettings = (0, mobx_react_1.observer)(function (props) {
    var sendSettingChangedTelemetry = (0, react_1.useCallback)(function (action) {
        var _a;
        return props.telemetry.track(Telemetry_1.TelemetryEventName.PageAccessSettingChanged, (_a = {},
            _a[TelemetryParameterKey_1.ProjectAccessSettingChangedFields.IsTemplate] = props.projectStore.isTemplate,
            _a[TelemetryParameterKey_1.ProjectAccessSettingChangedFields.Action] = action,
            _a), { blockIntercom: true, blockIdentify: true });
    }, []);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(IdentityMapping_1.IdentityMapping, { identityMappingStore: props.projectStore.linkStore.identityMappingStore, canUseIdentityMapping: props.canUseIdentityMapping, getUpsellMessage: props.getUpsellMessage, sendSettingChangedTelemetry: sendSettingChangedTelemetry }),
        react_1.default.createElement(PasswordProtect_1.PasswordProtect, { telemetry: props.telemetry, link: props.projectStore.links[0], updateLink: props.projectStore.updateLink, updateLinkPassword: props.projectStore.updateLinkPassword, disableSetting: !props.canUsePasswordProtect, getUpsellMessage: props.getUpsellMessage, sendSettingChangedTelemetry: sendSettingChangedTelemetry, isLive: props.projectStore.status === Types_1.ProjectStatus.Live })));
});
exports.SecuritySettings = SecuritySettings;
